/**
 * フローティングボタンのスクロールに応じた表示切り替え
 * @param {Object} config - 構成設定オブジェクト
 */
export const setupFloatingButtons = ({ floatButtonsSelector }) => {
  const floatButtons = document.querySelector(floatButtonsSelector);
  let startPosition = 0;
  let windowPosition;
  const scrollHeight = document.body.clientHeight;
  const windowHeight = window.innerHeight;
  //footer取得
  const footer = document.querySelector('footer');
  //footerの高さ
  const footerHeight = footer.offsetHeight;

  window.addEventListener('scroll', () => {
    windowPosition = window.scrollY;
    if (windowPosition <= startPosition) {
      floatButtons?.classList.add('fixedBtn--active');
    } else {
      floatButtons?.classList.remove('fixedBtn--active');
    }
    startPosition = windowPosition;

    if (scrollHeight + windowHeight - windowPosition <= footerHeight) {
      floatButtons?.classList.add('fixedBtn--passive');
    } else {
      floatButtons?.classList.remove('fixedBtn--passive');
    }
  });
};
